import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=1311162c"
import script from "./Features.vue?vue&type=script&setup=true&lang=js"
export * from "./Features.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Features.vue?vue&type=style&index=0&id=1311162c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports